<template>
  <div
    :id="blockId"
    class="element-editor shape-editor"
    :style="blockStyle"
  >
    <div class="shape" :style="style" :class="animateClass" />
  </div>
</template>

<script>
import utils from '@/util'
import presets from './shapes'

export default {
  name: 'ShapeEditor',
  props: {

    shape: {
      type: String,
      default: 'Rectangle',
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    shapeStyle: {
      type: Object,
      default: null,
    },
    animation: {
      type: String,
      default: '',
    },
    isInfinity: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    style() {
      let css = {}

      if (presets[this.shape]) {
        css['clip-path'] = presets[this.shape].value
      }

      if (this.shapeStyle) {
        css = {
          ...css,
          ...this.shapeStyle,
        }
      }

      return css
    },
    animateClass() {
      return utils.animateClass({
        animation: this.animation,
        isInfinity: this.isInfinity,
        duration: this.duration,
      })
    },
  },
  mounted() {
    this.$nextTick(() => { this.$emit('ready') })
  },
}
</script>

<style lang="scss" scoped>
.shape {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  touch-action: pan-x pan-y pinch-zoom;
}
</style>
